import { SearchField as RASearchField } from "react-aria-components";
import SearchIcon from "../../../img/icons/search.svg?react";
import { Button } from "../../buttons/Button";
import { FieldError } from "../FieldError";
import { FormLabel } from "../FormLabel";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import { Input } from "../Input";
import inputStyles from "../Input/Input.module.css";
import styles from "./SearchField.module.css";
import { ISearchField } from "./types";

const SearchField = ({
  labels: labelsProp,
  isDisabled,
  showCancelButton = false,
  ...props
}: ISearchField) => {
  const { searchField: defaults } = usePlosTranslations();
  const labels = {
    placeholder: labelsProp.placeholder ?? defaults.placeholder,
    cancelButton: labelsProp.cancelButton ?? defaults.cancelButton,
    label: labelsProp.label,
    description: labelsProp.description,
    errorMessage: labelsProp.errorMessage,
  };
  return (
    <RASearchField
      className={styles.searchFieldContainer}
      isDisabled={isDisabled}
      {...props}
    >
      <FormLabel
        label={labels.label}
        description={labels.description}
        isDisabled={isDisabled}
      />
      <div className={styles.searchFieldContent}>
        <div className={styles.searchFieldInputWrapper}>
          <Input
            className={inputStyles.searchInput}
            placeholder={labels.placeholder}
          />
          <SearchIcon className={styles.searchIcon} />
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <Button className={styles.clearButton}>✕</Button>
        </div>
        {showCancelButton && (
          <Button
            appearance="text"
            size="small"
            isDisabled={isDisabled}
            className={styles.cancelButton}
          >
            {labels.cancelButton}
          </Button>
        )}
      </div>
      <FieldError errorMessage={labels.errorMessage} />
    </RASearchField>
  );
};

export default SearchField;
